import { useTheme } from '@material-ui/core/styles';
import React from 'react';
import AceEditor from "react-ace";

interface Props {
  workflow: any;
}

function createSanitizedWorkflow(workflow) {
  const wf = { ...workflow };
  delete wf.Versions;
  delete wf.WorkflowStatus;
  return wf;
}

function WorkflowReadonlyJsonTab(props: Props) {
  const { workflow } = props;
  const theme = useTheme();

  return (
    <div>
      <AceEditor
        readOnly
        mode="json"
        theme={theme.palette.type === 'light' ? 'github' : 'monokai'}
        width="100%"
        maxLines={Infinity}
        minLines={25}
        value={JSON.stringify(createSanitizedWorkflow(workflow), null, 2)}
        name="workflow-json-model"
        setOptions={{ useWorker: false }}
        showPrintMargin={false}
        editorProps={{ $blockScrolling: true }}
        highlightActiveLine={false}
      />
    </div >
  );
};

export default WorkflowReadonlyJsonTab;
